<template>
  <div class="triggle_scl de_triggle_scl">
    <div
      v-for="(item, index) in list"
      :key="'g' + index"
      class="triggle_list"
      :class="{ triggle_cur: item.ischeck }"
      :style="item.IsShow==true?'':'display:none'"
    >
      <div class="triggle_line clearfix">
        <div v-if="item.ControlName && item.ControlName.trim() !== ''" class="Control_Name">
          {{ item.ControlName }}
        </div>
        <em
          class="triggle_more"
          @click="onCheck(item, index)"
        />
        <span class="triggle_span">{{ item.Desc }}</span>
        <div
          v-if="getIftttShowMode(item)"
          class="triggle_left"
        >
          <!-- <div class="triggle_left" v-if="item.ShowMode==1||item.ShowMode==3"> -->
          <div
            v-for="(model, t) in item.Values"
            :key="'b' + t"
            class="triggle_div"
            style="width:100%"
          >
            <div
              v-if="model.IsShow"
              class="triggle_ctr"
            >
              <div class="triggle_div2">
                <template v-if="model.ValueType == 'UIControl_Switch'">
                  <el-switch
                    v-model="model.DefaultValue"
                    class="triggle_switch"
                    active-color="#7dacee"
                    inactive-color="#d9e2f0"
                    :active-value="1"
                    :inactive-value="0"
                  />
                </template>
                <template v-if="model.ValueType == 'UIControl_Bright'">
                  <img
                    class="triggle_img1"
                    src="@/assets/img/icon_set-03.png"
                  >
                  <div class="triggle_slider">
                    <el-slider
                      v-model="model.DefaultValue"
                      :min="model.Min"
                      :max="100"
                      class="light_add"
                    />
                  </div>
                  <img
                    class="triggle_img2"
                    src="@/assets/img/icon_set-04.png"
                  >
                  <span style="position: absolute;display: inline-block;padding-left: 10px;padding-left: 42px;font-size: 12px;">%</span>
                  <el-input-number
                    v-model="model.DefaultValue"
                    class="input_number_action nopadding"
                    :min="1"
                    :max="100"
                    :precision="0"
                    style="padding:0;width: 50px;height:24px"
                  />
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {isMatched,getIftttShowMode,getClassSkuAndVersion} from '@/utils/utils'
export default {
  props:{
    list:{
      type:Array,
      default:()=>[]
    }
  },
  mounted(){
   
  },
  methods:{ 
    getControlName(item, index) {
      if (index % 2 === 0 && !item.ChannelId || item.ChannelId === 65535) return this.$t('scene.masterControl')

    },

    getIftttShowMode,
    onCheck(item, index) {
      this.$emit('check', item, index)
    },
    steppingactionclick (fmodel, model, _type) {
      model.DefaultValue = _type
    },
  }
}
</script>

<style lang="scss" scoped>
.Control_Name{
  position: relative;
  color: #3D3D3D;
}
.Control_Name::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 45px;
  width: calc(100% - 45px);
  height: 1px;
  background-color: #ccc;
}
</style>